import {
  AppBar,
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Link,
  makeStyles,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from '@material-ui/core';

import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import BreadCrumb from '../../../Components/BreadCrumb';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenDialogBox from '../../../global_components/KenDialogBox';
import routes from '../../../Utils/routes.json';
import { FaRegEdit } from 'react-icons/fa';
import { RiFilterLine } from 'react-icons/ri';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenPopover from '../../../Components/KenPopOver';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import { RiCheckLine } from 'react-icons/ri';
import { grey } from '@material-ui/core/colors';
import { RiCheckFill } from 'react-icons/ri';
import { dropDownOption } from '../AddProgram/data/data';
import {
  ExpandMore,
  LensTwoTone,
  Save,
  SettingsPhoneTwoTone,
} from '@material-ui/icons';
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { AiOutlinePlusSquare } from 'react-icons/ai';
import { useEffect } from 'react';
import KenInputField from '../../../global_components/KenInputField';
import KenGridEditable from '../../../global_components/kenEditDataGrid/kenGridEditable';
import './programDetails.css';
import moment from 'moment';

const ProgressCell = (row) => {
  // const { status } = row.row.values;
  const progressStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    color: row > 0 ? '#27AE60' : '#EF4060',
  };

  return (
    <Box style={progressStyle}>
      <Typography variant="span" style={{ alignItems: 'start' }}>
        {row}%
      </Typography>
      <LinearProgress variant="determinate" value={row} style={{ margin: 0 }} />
      <Typography variant="span" style={{ alignItems: 'start' }}>
        {row > 0 ? 'Ongoing' : 'Not yet started'}
      </Typography>
    </Box>
  );
};

const ActionCell = (row) => {
  return (
    <Box>
      <Button
        startIcon={<FaRegEdit />}
        variant="contained"
        color="primary"
        size="small"
        style={{ borderRadius: 15 }}
      >
        Edit
      </Button>
    </Box>
  );
};
const selectOptionsBatch = [
  {
    label: 'GMT Europe/London',
    value: 'gmt Europe/London',
  },
  {
    label: 'CET Europe/Berlin',
    value: 'cet Europe/Berlin',
  },
];
const selectOptionsSubject = [
  {
    label: 'Subject 1',
    value: 'subject 1',
  },
  {
    label: 'Subject 2',
    value: 'subject 2',
  },
];

const selectOptionsFaculty = [
  {
    label: 'faculty 1',
    value: 'Faculty 1',
  },
  {
    label: 'faculty 2',
    value: 'Faculty 2',
  },
];
const selectOptionsClass = [
  {
    label: 'class 1',
    value: 'Class 1',
  },
  {
    label: 'class 2',
    value: 'Class 2',
  },
];

const arrayBreadCrumb = [
  { head: 'HOME', url: routes.home },
  {
    head: 'CURRENT PROGRAMMES',
    url: routes.currentProgrammes,
  },
  {
    head: 'PROGRAM PLAN',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  filterRow: {
    display: 'flex',
    flexDirection: 'row-reverse',
    margin: '2rem 0 1rem',
  },
  noDataFound: {
    fontWeight: '600',
    fontSize: '14px',
  },
  filterButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
}));

const selectOptions = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
];

const selectOptionsType = [
  {
    label: 'Type 1',
    value: '1',
  },
  {
    label: 'Type 2',
    value: '2',
  },
];
const programOptions = [
  {
    label: 'Project Cost Estimation',
    value: '1',
  },
  {
    label: 'Project Management Introduction',
    value: '2',
  },
  {
    label: 'Project Planning & scope',
    value: '3',
  },
  {
    label: 'Project Scheduling',
    value: '4',
  },
];

const workShopArray = [
  'Subject',
  'Start date',
  'End date',
  'Start Time',
  'End Time',
  'TZ',
  'Facility',
  'Class Room',
  'Action',
];
const createData = (
  id,
  course,
  subject,
  candidates,
  date,
  start_time,
  end_time,
  duration,
  exam_type,
  venue_link,
  status,
  holiday,
  saved
) => ({
  id,
  course,
  subject,
  candidates,
  date,
  start_time,
  end_time,
  duration,
  exam_type,
  venue_link,
  status,
  holiday,
  saved,
});

const createDatas = (
  id,
  subject,
  start_date,
  end_date,
  start_time,
  end_time,
  tz,
  facility,
  classroom,
  saves
) => ({
  id,
  subject,
  start_date,
  end_date,
  start_time,
  end_time,
  tz,
  facility,
  classroom,
  saves,
});
const ProgramDetails = () => {
  const columnData = [
    'SUBJECT/UNIT',
    'Credits',
    'Start Date',
    'End Date',
    'Start Time',
    'End Time',
    'TZ',
    'Faculty',
    'Class Room',
    'Status',
    'Holiday',
    'Actions',
  ];
  const [previous, setPrevious] = useState({});

  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onToggleSecondEdit = (id, rowes) => {
    setRowSecond((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const onToggleEditWorkshop = (id, rowes) => {
    setRowWorkShop((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onToggleEditSecondWorkshop = (id, rowes) => {
    setsecondRowWorkShop((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        row.start_time = moment(row.start_time, 'HH:mm:ss').format('LT');
        row.end_time = moment(row.end_time, 'HH:mm:ss').format('LT');
        return row;
      }

      return row;
    });

    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };
  const onSecondRevert = (id) => {
    const newRows = rowSecond.map((row) => {
      if (row.id === id) {
        row.start_time = moment(row.start_time, 'HH:mm:ss').format('LT');
        row.end_time = moment(row.end_time, 'HH:mm:ss').format('LT');
        return row;
      }
      return row;
    });
    setRowSecond(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleSecondEdit(id, newRows);
  };

  const onRevertWorkShop = (id) => {
    const newRows = rowWorkShop.map((row) => {
      if (row.id === id) {
        row.start_time = moment(row.start_time, 'HH:mm:ss').format('LT');
        row.end_time = moment(row.end_time, 'HH:mm:ss').format('LT');
        return row;
      }
      return row;
    });
    setRowWorkShop(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEditWorkshop(id, newRows);
  };
  const onRevertSecondWorkShop = (id) => {
    const newRows = secondRowWorkShop.map((row) => {
      if (row.id === id) {
        row.start_time = moment(row.start_time, 'HH:mm:ss').format('LT');
        row.end_time = moment(row.end_time, 'HH:mm:ss').format('LT');
        return row;
      }
      return row;
    });
    setsecondRowWorkShop(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEditSecondWorkshop(id, newRows);
  };
  const onChange = (e, row) => {
    console.log('erow', e, row);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const onSecondChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rowSecond.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRowSecond(newRows);
  };
  const onChangeWorkshop = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    console.log('new-->', e, row, value, name, id);
    const newRows = rowWorkShop.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRowWorkShop(newRows);
  };
  const onChangeSecondWorkshop = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    console.log('new-->', e, row, value, name, id);
    const newRows = secondRowWorkShop.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setsecondRowWorkShop(newRows);
  };
  const onToggleEditMode = (id) => {
    setRows((state) => {
      return rows.map((row) => {
        if (row.id === id) {
          row.start_time = moment(row.start_time, 'HH:mm:ss').format('LT');
          row.end_time = moment(row.end_time, 'HH:mm:ss').format('LT');
          if (row.start_time === 'Invalid date') {
            row.start_time = moment().format('hh:mm');
          }
          if (row.end_time === 'Invalid date') {
            row.end_time = moment().format('hh:mm');
          }

          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onToggleSecondEditMode = (id) => {
    setRowSecond((state) => {
      return rowSecond.map((row) => {
        if (row.id === id) {
          row.start_time = moment(row.start_time, 'HH:mm:ss').format('LT');
          row.end_time = moment(row.end_time, 'HH:mm:ss').format('LT');
          if (row.start_time === 'Invalid date') {
            row.start_time = moment().format('hh:mm');
          }
          if (row.end_time === 'Invalid date') {
            row.end_time = moment().format('hh:mm');
          }
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const onToggleEditModeWorkshop = (id) => {
    setRowWorkShop((state) => {
      return rowWorkShop.map((row) => {
        if (row.id === id) {
          row.start_time = moment(row.start_time, 'HH:mm:ss').format('LT');
          row.end_time = moment(row.end_time, 'HH:mm:ss').format('LT');
          if (row.start_time === 'Invalid date') {
            row.start_time = moment().format('hh:mm');
          }
          if (row.end_time === 'Invalid date') {
            row.end_time = moment().format('hh:mm');
          }
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const onToggleEditModeSecondWorkshop = (id) => {
    setsecondRowWorkShop((state) => {
      return secondRowWorkShop.map((row) => {
        if (row.id === id) {
          row.start_time = moment(row.start_time, 'HH:mm:ss').format('LT');
          row.end_time = moment(row.end_time, 'HH:mm:ss').format('LT');
          if (row.start_time === 'Invalid date') {
            row.start_time = moment().format('hh:mm');
          }
          if (row.end_time === 'Invalid date') {
            row.end_time = moment().format('hh:mm');
          }
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const handlePopoverOpen = (event) => {
    setAnchorEls(event.currentTarget);
  };
  const UserCell = (row, popOverOpen) => {
    return <p onMouseEnter={(e) => popOverOpen(e)}>{row}</p>;
  };
  const [rows, setRows] = useState([
    createData(
      134,
      'Project Cost Estimation',
      9,
      '01/01/2020',
      '31/12/2022',
      '10:30 AM',
      '1:30 PM',
      'GMT Europe/London',
      'Prof Raju',
      'Mumbai CLR 001',
      ProgressCell(50),
      1,
      false
    ),
    createData(
      234,
      'Project Cost Estimation1',
      9,
      '01/01/2020',
      '31/12/2022',
      '10:30 AM',
      '1:30 PM',
      'GMT Europe/London',
      'Prof Raju',
      'Mumbai CLR 001',
      ProgressCell(0),
      1,
      false
    ),
    createData(
      334,
      'Project Cost Estimation2',
      9,
      '01/01/2020',
      '31/12/2022',
      '10:30 AM',
      '1:30 PM',
      'GMT Europe/London',
      'Prof Raju',
      'Mumbai CLR 001',
      ProgressCell(0),
      1,
      false
    ),
  ]);
  const [rowSecond, setRowSecond] = useState([]);

  const [rowWorkShop, setRowWorkShop] = useState([]);
  const [secondRowWorkShop, setsecondRowWorkShop] = useState([]);

  const classes = useStyles();
  const history = useHistory();
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [campusValue, setCampusValue] = useState(dropDownOption[0].value);
  const [programValue, setProgramValue] = useState(programOptions[0].value);
  const [typeValue, setTypeValue] = useState(selectOptionsType[0].value);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEls, setAnchorEls] = React.useState(null);
  const [startData, setStartDate] = useState('25-02-2022');
  const [startDates, setStartDated] = useState('25-02-2022');
  const [subject, setSubject] = useState('');
  const [exam, setExam] = useState('');
  const [workshop, setWorkShop] = useState(false);
  const [secondWorkshop, setsecondWorkshop] = useState(false);

  const [accordienCheck, setAccordienCheck] = useState(true);
  const [accordienSecondCheck, setAccordienSecondCheck] = useState(false);

  const [endData, setEndDate] = useState('25-02-2022');
  const [filterCurrentDialog, setFilterCurrentDialog] = useState(false);
  // const [dataSet, setDataSet] = useState(data);
  const [filters, setFilters] = useState({});
  /**
   * Table popover functionalityx
   */
  const [gradeInp, setGradeInp] = useState({});
  const [dataStream, setDataStream] = useState({});
  const [dataWorkshop, setDataWorkShop] = useState({});
  const [dataSecondWorkshop, setDataSecondWorkShop] = useState({});

  const [Inp, setInp] = useState('');
  const [inputs, setInputs] = useState({});
  const [isEdit, setsEdit] = useState(true);
  const [selectValueBatch, setSelectValueBatch] = useState(
    selectOptionsBatch[0].value
  );
  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );

  const [selectValueFaculty, setSelectValueFaculty] = useState(
    selectOptionsFaculty[0].value
  );
  const [selectValueClass, setSelectValueClass] = useState(
    selectOptionsClass[0].value
  );

  const handleSelectChangeBatch = (event) => {
    dataStream.tz = event.target.value;
    setSelectValueBatch(event.target.value);
  };

  const handleSelectChangeBatch1 = (event) => {
    dataWorkshop.tz = event.target.value;
    setSelectValueBatch(event.target.value);
  };
  const handleSelectChangeSubject = (event) => {
    dataStream.subject = event.target.value;
    setSelectValueSubject(event.target.value);
  };
  const handleSelectChangeSubject1 = (event) => {
    dataWorkshop.subject = event.target.value;
    setSelectValueSubject(event.target.value);
  };

  const handleSelectChangeFaculty = (event) => {
    dataStream.faculty = event.target.value;
    setSelectValueFaculty(event.target.value);
  };
  const handleSelectChangeFaculty1 = (event) => {
    dataWorkshop.faculty = event.target.value;
    setSelectValueFaculty(event.target.value);
  };
  const handleSelectChangeClass = (event) => {
    dataStream.class = event.target.value;
    setSelectValueClass(event.target.value);
  };

  const handleSelectChangeClass1 = (event) => {
    dataWorkshop.class = event.target.value;
    setSelectValueClass(event.target.value);
  };

  const opens = Boolean(anchorEls);
  const ids = opens ? 'simple-popover' : undefined;
  const handleChange = (event) => {
    setGradeInp({
      [event.target.name]: event.target.value,
    });
  };

  const handleChangedSubject = (event) => {
    dataStream.subject = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedCredit = (event) => {
    dataStream.credit = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };

  const handleChangedDate = (event) => {
    dataStream.startDate = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };

  const handleChangedDate1 = (event) => {
    dataWorkshop.startDate = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedEndDate = (event) => {
    console.log('object', event.target.value);
    dataStream.endDate = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedEndDate1 = (event) => {
    console.log('object', event.target.value);
    dataWorkshop.endDate = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };

  const handleChangedTime = (event) => {
    var formatted = moment(event.target.value, 'HH:mm:ss').format('LT');
    dataStream.time = formatted;
  };

  const handleChangedEndTime = (event) => {
    var formatted = moment(event.target.value, 'HH:mm:ss').format('LT');
    dataStream.endTime = formatted;
  };

  const handleChangedExam = (event) => {
    dataStream.exam = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };

  const handleChangedVenue = (event) => {
    dataStream.venue = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedStatus = (event) => {
    dataStream.status = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedHoliday = (event) => {
    console.log('handleChangedHoliday', event.target.value);
    dataStream.holiday = event.target.value;
  };
  useEffect(() => {
    console.log('dataStream', dataStream);
  }, [dataStream]);
  const handlePopoverClose = () => {
    setAnchorEls(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const manageStartDate = (e) => {
    console.log('date', e.target.value);
    setStartDate(e.target.value);
  };

  const manageStartDates = (e) => {
    console.log('date', e.target.value);
    setStartDate(e.target.value);
  };

  const manageEndDate = (e) => {
    setEndDate(e.target.value);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleSelectChange = (e) => {
    setSelectValue(e.target.value);
  };
  const handleSelectProgramChange = (e) => {
    setProgramValue(e.target.value);
  };
  const handleSelectTypeChange = (e) => {
    setTypeValue(e.target.value);
  };

  const handleSelectCampusChange = (e) => {
    setCampusValue(e.target.value);
  };

  function handleFilterCurrentDialog() {
    setFilterCurrentDialog((prevState) => !prevState);
  }

  const subjectOptions = [
    {
      label: 'Subject 1',
      value: '1',
    },
    {
      label: 'Subject 2',
      value: '2',
    },
    {
      label: 'Subject 3',
      value: '3',
    },
  ];
  const handleFilter = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };
  const handleCancel = (row) => {
    setRows((pre) => pre.filter((item) => item.id !== row));
  };
  const handleSecondCancel = (row) => {
    setRowSecond((pre) => pre.filter((item) => item.id !== row));
  };
  const handleCancelWorkshop = (row) => {
    setRowWorkShop((pre) => pre.filter((item) => item.id !== row));
  };
  const handleCancelSecondWorkshop = (row) => {
    setsecondRowWorkShop((pre) => pre.filter((item) => item.id !== row));
  };
  const handleSecondSubject = (check, id) => {
    if (check == 'save') {
      const newRows = rowSecond.map((row) => {
        if (row.id === id.id) {
          return {
            ...row,
            id: row.id,
            course: dataStream.subject,
            subject: dataStream.credit,
            candidates: dataStream.startDate,
            date: dataStream.endDate,
            start_time: dataStream.time,
            end_time: dataStream.endTime,
            duration: dataStream.tz,
            exam_type: dataStream.faculty,
            venue_link: dataStream.class,
            status: ProgressCell(dataStream.status),
            holiday: dataStream.holiday,
            saved: false,
          };
        }
        return row;
      });
      setRowSecond(newRows);
      setDataStream({});
    } else {
      setRowSecond([
        ...rowSecond,
        createData(
          `rowSecond${rowSecond.length}`,
          <KenSelectWrap
            label="Subject"
            options={selectOptionsSubject}
            value={dataStream.subject}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeSubject}
            required
          />,
          <KenInputField
            name={'subject'}
            label="Credit Point"
            value={dataStream.credit}
            optionalLabel={false}
            onChange={(e) => handleChangedCredit(e)}
            style={{ fontSize: 12 }}
          />,
          <KenDateTimePicker
            name={'startDate'}
            value={dataStream.startDate}
            label="Start Date"
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => handleChangedDate(e)}
          />,
          <>
            <KenDateTimePicker
              name={'name'}
              // inputBaseRootClass={classes.kenDateTimePickerColor}
              label="End Date"
              value={dataStream.endDate}
              type="date"
              required={true}
              onChange={(e) => handleChangedEndDate(e)}
            />
          </>,
          <KenDateTimePicker
            name={'name'}
            label="Start Time"
            // inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="Start Time"
            value={dataStream.time}
            type="time"
            required={true}
            onChange={(e) => handleChangedTime(e)}
          />,
          <KenDateTimePicker
            name={'name'}
            label="End Time"
            // inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="End Time"
            value={dataStream.endTime}
            type="time"
            required={true}
            onChange={(e) => handleChangedEndTime(e)}
          />,

          <KenSelectWrap
            label="TZ"
            options={selectOptionsBatch}
            value={dataStream.tz}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleSelectChangeBatch(e)}
            required
          />,
          <KenSelectWrap
            label="Faculty"
            options={selectOptionsFaculty}
            value={dataStream.faculty}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeFaculty}
            required
          />,
          <KenSelectWrap
            label="Class Room"
            options={selectOptionsClass}
            value={dataStream.class}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeClass}
            required
          />,
          <KenInputField
            name={'status'}
            label="Status %"
            value={dataStream.status}
            optionalLabel={false}
            onChange={handleChangedStatus}
            style={{ fontSize: 12 }}
          />,
          <KenInputField
            name={'holiday'}
            label="Holiday"
            value={dataStream.holiday}
            optionalLabel={false}
            onChange={handleChangedHoliday}
            style={{ fontSize: 12 }}
          />,
          true
        ),
      ]);
    }
  };

  const handleSubject = (check, id) => {
    if (check == 'save') {
      const newRows = rows.map((row) => {
        console.log('dataStream.time', dataStream, row);
        if (row.id === id.id) {
          return {
            ...row,
            id: row.id,
            course: dataStream.subject,
            subject: dataStream.credit,
            candidates: dataStream.startDate,
            date: dataStream.endDate,
            start_time: dataStream.time,
            end_time: dataStream.endTime,
            duration: dataStream.tz,
            exam_type: dataStream.faculty,
            venue_link: dataStream.class,
            status: ProgressCell(dataStream.status),
            holiday: dataStream.holiday,
            saved: false,
          };
        }
        return row;
      });
      setRows(newRows);
      setDataStream({});
    } else {
      console.log('dataStream', dataStream.startDate, rows);
      setRows([
        ...rows,
        createData(
          `rows${rows.length}`,
          <KenSelectWrap
            label="Subject"
            options={selectOptionsSubject}
            value={dataStream.subject}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeSubject}
            required
          />,
          <KenInputField
            name={'subject'}
            label="Credit Point"
            value={dataStream.credit}
            optionalLabel={false}
            onChange={(e) => handleChangedCredit(e)}
            style={{ fontSize: 12 }}
          />,
          <KenDateTimePicker
            name={'startDate'}
            value={dataStream.startDate}
            label="Start Date"
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => handleChangedDate(e)}
          />,
          <>
            <KenDateTimePicker
              name={'name'}
              // inputBaseRootClass={classes.kenDateTimePickerColor}
              label="End Date"
              value={dataStream.endDate}
              type="date"
              required={true}
              onChange={(e) => handleChangedEndDate(e)}
            />
          </>,
          <KenDateTimePicker
            name={'name'}
            label="Start Time"
            // inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="Start Time"
            value={dataStream.time}
            type="time"
            required={true}
            onChange={(e) => handleChangedTime(e)}
          />,
          <KenDateTimePicker
            name={'name'}
            label="End Time"
            // inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="End Time"
            value={dataStream.endTime}
            type="time"
            required={true}
            onChange={(e) => handleChangedEndTime(e)}
          />,

          <KenSelectWrap
            label="TZ"
            options={selectOptionsBatch}
            value={dataStream.tz}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleSelectChangeBatch(e)}
            required
          />,
          <KenSelectWrap
            label="Faculty"
            options={selectOptionsFaculty}
            value={dataStream.faculty}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeFaculty}
            required
          />,
          <KenSelectWrap
            label="Class Room"
            options={selectOptionsClass}
            value={dataStream.class}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeClass}
            required
          />,
          <KenInputField
            name={'status'}
            label="Status %"
            value={dataStream.status}
            optionalLabel={false}
            onChange={handleChangedStatus}
            style={{ fontSize: 12 }}
          />,
          <KenInputField
            name={'holiday'}
            label="Holiday"
            value={dataStream.holiday}
            optionalLabel={false}
            onChange={handleChangedHoliday}
            style={{ fontSize: 12 }}
          />,
          true
        ),
      ]);
    }
  };

  const handleWorkShop = (check, id) => {
    setWorkShop(true);
    if (check == 'save') {
      const newRows = rowWorkShop.map((row) => {
        if (row.id === id.id) {
          return {
            ...row,
            id: row.id,
            subject: dataWorkshop.subject,
            start_date: dataWorkshop.startDate,
            end_date: dataWorkshop.endDate,
            start_time: dataStream.time,
            end_time: dataStream.endTime,
            tz: dataWorkshop.tz,
            facility: dataWorkshop.faculty,
            classroom: dataWorkshop.class,
            saves: false,
          };
        }
        return row;
      });
      setRowWorkShop(newRows);
      setDataWorkShop({});
    } else {
      setRowWorkShop([
        ...rowWorkShop,
        createDatas(
          rowWorkShop.length + 1,
          <KenSelectWrap
            label="Subject"
            options={selectOptionsSubject}
            value={dataWorkshop.subject}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeSubject1}
            required
          />,
          <KenDateTimePicker
            name={'startDate'}
            label="Start Date"
            value={dataWorkshop.startDate}
            type="date"
            required={true}
            onChange={(e) => handleChangedDate1(e)}
          />,
          <KenDateTimePicker
            name={'endDate'}
            label="End Date"
            value={dataWorkshop.endDate}
            type="date"
            required={true}
            onChange={(e) => handleChangedEndDate1(e)}
          />,
          <KenDateTimePicker
            name={'name'}
            label="Start Time"
            // inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="Start Time"
            value={dataStream.time}
            type="time"
            required={true}
            onChange={(e) => handleChangedTime(e)}
          />,
          <KenDateTimePicker
            name={'name'}
            label="End Time"
            // inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="End Time"
            value={dataStream.endTime}
            type="time"
            required={true}
            onChange={(e) => handleChangedEndTime(e)}
          />,
          <KenSelectWrap
            label="TZ"
            options={selectOptionsBatch}
            value={dataWorkshop.tz}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleSelectChangeBatch1(e)}
            required
          />,
          <KenSelectWrap
            label="Faculty"
            options={selectOptionsFaculty}
            value={dataWorkshop.faculty}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeFaculty1}
            required
          />,
          <KenSelectWrap
            label="Class Room"
            options={selectOptionsClass}
            value={dataWorkshop.class}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeClass1}
            required
          />,
          true
        ),
      ]);
    }
  };
  const handleSecondWorkShop = (check, id) => {
    setsecondWorkshop(true);
    if (check == 'save') {
      const newRows = secondRowWorkShop.map((row) => {
        if (row.id === id.id) {
          return {
            ...row,
            id: row.id,
            subject: dataWorkshop.subject,
            start_date: dataWorkshop.startDate,
            end_date: dataWorkshop.endDate,
            start_time: dataStream.time,
            end_time: dataStream.endTime,
            tz: dataWorkshop.tz,
            facility: dataWorkshop.faculty,
            classroom: dataWorkshop.class,
            saves: false,
          };
        }
        return row;
      });
      setsecondRowWorkShop(newRows);
      setDataWorkShop({});
    } else {
      setsecondRowWorkShop([
        ...secondRowWorkShop,
        createDatas(
          `secondRowWorkShop${secondRowWorkShop.length + 100}`,
          <KenSelectWrap
            label="Subject"
            options={selectOptionsSubject}
            value={dataWorkshop.subject}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeSubject1}
            required
          />,
          <KenDateTimePicker
            name={'startDate'}
            label="Start Date"
            value={dataWorkshop.startDate}
            type="date"
            required={true}
            onChange={(e) => handleChangedDate1(e)}
          />,
          <KenDateTimePicker
            name={'endDate'}
            label="End Date"
            value={dataWorkshop.endDate}
            type="date"
            required={true}
            onChange={(e) => handleChangedEndDate1(e)}
          />,
          <KenDateTimePicker
            name={'name'}
            label="Start Time"
            // inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="Start Time"
            value={dataStream.time}
            type="time"
            required={true}
            onChange={(e) => handleChangedTime(e)}
          />,
          <KenDateTimePicker
            name={'name'}
            label="End Time"
            // inputBaseRootClass={classes.kenDateTimePickerColor}
            placeholder="End Time"
            value={dataStream.endTime}
            type="time"
            required={true}
            onChange={(e) => handleChangedEndTime(e)}
          />,

          <KenSelectWrap
            label="TZ"
            options={selectOptionsBatch}
            value={dataWorkshop.tz}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleSelectChangeBatch1(e)}
            required
          />,
          <KenSelectWrap
            label="Faculty"
            options={selectOptionsFaculty}
            value={dataWorkshop.faculty}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeFaculty1}
            required
          />,
          <KenSelectWrap
            label="Class Room"
            options={selectOptionsClass}
            value={dataWorkshop.class}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeClass1}
            required
          />,
          true
        ),
      ]);
    }
  };

  useEffect(() => {
    setInputs(gradeInp, filters);
  }, [gradeInp]);
  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Current Programmes
          </Typography>
        </Toolbar>
      </AppBar>

      <Box className={classes.filterRow}>
        <Button
          className={classes.filterButton}
          startIcon={<RiFilterLine />}
          variant="contained"
          color="primary"
          onClick={handleFilterCurrentDialog}
        >
          Filter
        </Button>
      </Box>

      <Box className="cardlsitbox">
        <Accordion expanded={accordienCheck}>
          <AccordionSummary
            expandIcon={accordienCheck}
            onClick={() => setAccordienCheck(!accordienCheck)}
          >
            {accordienCheck ? (
              <AiOutlineMinusSquare size={20} />
            ) : (
              <AiOutlinePlusSquare size={20} />
            )}{' '}
            &nbsp;{' '}
            <span style={{ color: '#092682', font: 'Open Sans' }}>Term 1</span>
          </AccordionSummary>
          {/* <AccordionDetails> */}
          <KenCard elevation={0}>
            <h5 style={{ margin: '0 20px 10px 10px' }}>Subjects</h5>
            <hr></hr>
            <TableContainer>
              <Table className={classes.table} aria-label="caption table">
                <TableHead>
                  <TableRow>
                    {columnData.map((ele) => (
                      <TableCell align="left">{ele}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => {
                    return (
                      <TableRow key={row.id}>
                        <KenGridEditable
                          {...{
                            row,
                            onChange,
                            columns: [
                              {
                                column_name: 'course',
                                is_inline_edit: false,
                                inline_edit_type: 'kenSelect',
                                dropdown: selectOptionsSubject,
                                label: 'Course',
                              },
                              {
                                column_name: 'subject',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'Subject',
                              },
                              {
                                column_name: 'candidates',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'Candidates',
                              },
                              {
                                column_name: 'date',
                                is_inline_edit: true,
                                inline_edit_type: 'kenDatePicker',
                                label: 'Date',
                              },
                              {
                                column_name: 'start_time',
                                is_inline_edit: true,
                                inline_edit_type: 'kenTime',
                                label: 'Start time',
                              },
                              {
                                column_name: 'end_time',
                                is_inline_edit: true,
                                inline_edit_type: 'kenTime',
                                label: 'End time',
                              },

                              {
                                column_name: 'duration',
                                is_inline_edit: true,
                                inline_edit_type: 'kenSelect',
                                dropdown: selectOptionsBatch,
                                label: 'Tz',
                              },
                              {
                                column_name: 'exam_type',
                                is_inline_edit: true,
                                inline_edit_type: 'kenSelect',
                                dropdown: selectOptionsFaculty,
                                label: 'Faculty',
                              },
                              {
                                column_name: 'venue_link',
                                is_inline_edit: true,
                                inline_edit_type: 'kenSelect',
                                dropdown: selectOptionsClass,
                                label: 'Class',
                              },

                              {
                                column_name: 'status',
                                is_inline_edit: true,
                                inline_edit_type: '',
                                label: 'Status',
                              },
                              {
                                column_name: 'holiday',
                                is_inline_edit: true,
                                inline_edit_type: '',
                                label: 'Holiday',
                              },
                            ],
                          }}
                        />
                        <TableCell className={classes.selectTableCell}>
                          {row.isEditMode ? (
                            <>
                              <IconButton
                                aria-label="done"
                                onClick={() => onToggleEditMode(row.id)}
                              >
                                <DoneIcon />
                              </IconButton>
                              <IconButton
                                aria-label="revert"
                                onClick={() => onRevert(row.id)}
                              >
                                <RevertIcon />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              {!row.saved && (
                                <IconButton
                                  aria-label="delete"
                                  onClick={() => onToggleEditMode(row.id)}
                                >
                                  <EditIcon />
                                </IconButton>
                              )}
                              {row.saved && (
                                <>
                                  <IconButton
                                    aria-label="done"
                                    onClick={() => handleSubject('save', row)}
                                  >
                                    <DoneIcon />
                                  </IconButton>
                                  <IconButton
                                    aria-label="revert"
                                    onClick={() => handleCancel(row.id)}
                                  >
                                    <RevertIcon />
                                  </IconButton>
                                </>
                              )}
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </KenCard>
          {workshop ? (
            <KenCard elevation={0}>
              <h5 style={{ margin: '0 20px 10px 10px' }}>WorkShops</h5>
              <hr></hr>
              <TableContainer>
                <Table className={classes.table} aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      {workShopArray.map((ele) => (
                        <TableCell align="left">{ele}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowWorkShop.map((row) => {
                      return (
                        <TableRow key={row.id}>
                          <KenGridEditable
                            onChange={onChangeWorkshop}
                            {...{
                              row,
                              columns: [
                                {
                                  column_name: 'subject',
                                  is_inline_edit: false,
                                  inline_edit_type: '',
                                  label: 'Subject',
                                },
                                {
                                  column_name: 'start_date',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenDatePicker',
                                  label: 'Start Date',
                                },
                                {
                                  column_name: 'end_date',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenDatePicker',
                                  label: 'End Date',
                                },
                                {
                                  column_name: 'start_time',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenTime',
                                  label: 'Start time',
                                },
                                {
                                  column_name: 'end_time',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenTime',
                                  label: 'End time',
                                },
                                {
                                  column_name: 'tz',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenSelect',
                                  dropdown: selectOptionsBatch,
                                  label: 'Tz',
                                },
                                {
                                  column_name: 'facility',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenSelect',
                                  dropdown: selectOptionsFaculty,
                                  label: 'Faculty',
                                },
                                {
                                  column_name: 'classroom',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenSelect',
                                  dropdown: selectOptionsClass,
                                  label: 'Class',
                                },
                              ],
                            }}
                          />
                          <TableCell className={classes.selectTableCell}>
                            {row.isEditMode ? (
                              <>
                                <IconButton
                                  aria-label="done"
                                  onClick={() =>
                                    onToggleEditModeWorkshop(row.id)
                                  }
                                >
                                  <DoneIcon />
                                </IconButton>
                                <IconButton
                                  aria-label="revert"
                                  onClick={() => onRevertWorkShop(row.id)}
                                >
                                  <RevertIcon />
                                </IconButton>
                              </>
                            ) : (
                              <>
                                {!row.saves && (
                                  <>
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() =>
                                        onToggleEditModeWorkshop(row.id)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  </>
                                )}
                                {row.saves && (
                                  <>
                                    <IconButton
                                      aria-label="done"
                                      onClick={() =>
                                        handleWorkShop('save', row)
                                      }
                                    >
                                      <DoneIcon />
                                    </IconButton>
                                    <IconButton
                                      aria-label="revert"
                                      onClick={() =>
                                        handleCancelWorkshop(row.id)
                                      }
                                    >
                                      <RevertIcon />
                                    </IconButton>
                                  </>
                                )}
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </KenCard>
          ) : (
            ''
          )}{' '}
          {/* </AccordionDetails>{' '} */}
          <div style={{ marginLeft: '15px' }}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{ marginRight: '15px' }}
              onClick={() => handleSubject()}
            >
              Add Subjects
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => handleWorkShop()}
            >
              Add workshop
            </Button>
          </div>
        </Accordion>
      </Box>
      <Box className="cardlsitbox">
        <Accordion expanded={accordienSecondCheck} className="accordienMg">
          <AccordionSummary
            expandIcon={accordienSecondCheck}
            onClick={() => setAccordienSecondCheck(!accordienSecondCheck)}
          >
            {accordienSecondCheck ? (
              <AiOutlineMinusSquare size={20} />
            ) : (
              <AiOutlinePlusSquare size={20} />
            )}{' '}
            &nbsp;{' '}
            <span style={{ color: '#092682', font: 'Open Sans' }}>Term 2</span>
          </AccordionSummary>
          <AccordionDetails>
            <KenCard elevation={0}>
              <TableContainer>
                <Table className={classes.table} aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      {columnData.map((ele) => (
                        <TableCell align="left">{ele}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowSecond.length > 0 ? (
                      rowSecond.map((row) => {
                        return (
                          <TableRow key={row.id}>
                            <KenGridEditable
                              onChange={onSecondChange}
                              {...{
                                row,
                                columns: [
                                  {
                                    column_name: 'course',
                                    is_inline_edit: false,
                                    inline_edit_type: 'kenSelect',
                                    dropdown: selectOptionsSubject,
                                    label: 'Course',
                                  },
                                  {
                                    column_name: 'subject',
                                    is_inline_edit: false,
                                    inline_edit_type: '',
                                    label: 'Subject',
                                  },
                                  {
                                    column_name: 'candidates',
                                    is_inline_edit: false,
                                    inline_edit_type: '',
                                    label: 'Candidates',
                                  },
                                  {
                                    column_name: 'date',
                                    is_inline_edit: true,
                                    inline_edit_type: 'kenDatePicker',
                                    label: 'Date',
                                  },
                                  {
                                    column_name: 'start_time',
                                    is_inline_edit: true,
                                    inline_edit_type: 'kenTime',
                                    label: 'Start time',
                                  },
                                  {
                                    column_name: 'end_time',
                                    is_inline_edit: true,
                                    inline_edit_type: 'kenTime',
                                    label: 'End time',
                                  },
                                  {
                                    column_name: 'duration',
                                    is_inline_edit: true,
                                    inline_edit_type: 'kenSelect',
                                    dropdown: selectOptionsBatch,
                                    label: 'TZ',
                                  },
                                  {
                                    column_name: 'exam_type',
                                    is_inline_edit: true,
                                    inline_edit_type: 'kenSelect',
                                    dropdown: selectOptionsFaculty,
                                    label: 'Faculty',
                                  },
                                  {
                                    column_name: 'venue_link',
                                    is_inline_edit: true,
                                    inline_edit_type: 'kenSelect',
                                    dropdown: selectOptionsClass,
                                    label: 'Class Room',
                                  },

                                  {
                                    column_name: 'status',
                                    is_inline_edit: true,
                                    inline_edit_type: '',
                                    label: 'Status',
                                  },
                                  {
                                    column_name: 'holiday',
                                    is_inline_edit: true,
                                    inline_edit_type: '',
                                    label: 'Holiday',
                                  },
                                ],
                              }}
                            />
                            <TableCell className={classes.selectTableCell}>
                              {row.isEditMode ? (
                                <>
                                  <IconButton
                                    aria-label="done"
                                    onClick={() =>
                                      onToggleSecondEditMode(row.id)
                                    }
                                  >
                                    <DoneIcon />
                                  </IconButton>
                                  <IconButton
                                    aria-label="revert"
                                    onClick={() => onSecondRevert(row.id)}
                                  >
                                    <RevertIcon />
                                  </IconButton>
                                </>
                              ) : (
                                <>
                                  {!row.saved && (
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() =>
                                        onToggleSecondEditMode(row.id)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  )}
                                  {row.saved && (
                                    <>
                                      <IconButton
                                        aria-label="done"
                                        onClick={() =>
                                          handleSecondSubject('save', row)
                                        }
                                      >
                                        <DoneIcon />
                                      </IconButton>
                                      <IconButton
                                        aria-label="revert"
                                        onClick={() =>
                                          handleSecondCancel(row.id)
                                        }
                                      >
                                        <RevertIcon />
                                      </IconButton>
                                    </>
                                  )}
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        {' '}
                        <TableCell
                          className={classes.noDataFound}
                          colSpan={10}
                          align="center"
                        >
                          No Data
                        </TableCell>{' '}
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </KenCard>
          </AccordionDetails>{' '}
          {secondWorkshop ? (
            <KenCard elevation={0}>
              <h5 style={{ margin: '0 20px 10px 10px' }}>WorkShops</h5>
              <hr></hr>
              <TableContainer>
                <Table className={classes.table} aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      {workShopArray.map((ele) => (
                        <TableCell align="left">{ele}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {secondRowWorkShop.map((row) => {
                      return (
                        <TableRow key={row.id}>
                          <KenGridEditable
                            onChange={onChangeSecondWorkshop}
                            {...{
                              row,
                              columns: [
                                {
                                  column_name: 'subject',
                                  is_inline_edit: false,
                                  inline_edit_type: '',
                                  label: 'Subject',
                                },
                                {
                                  column_name: 'start_date',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenDatePicker',
                                  label: 'Start Date',
                                },
                                {
                                  column_name: 'end_date',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenDatePicker',
                                  label: 'End Date',
                                },
                                {
                                  column_name: 'start_time',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenTime',
                                  label: 'Start time',
                                },
                                {
                                  column_name: 'end_time',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenTime',
                                  label: 'End time',
                                },
                                {
                                  column_name: 'tz',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenSelect',
                                  dropdown: selectOptionsBatch,
                                  label: 'Tz',
                                },
                                {
                                  column_name: 'facility',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenSelect',
                                  dropdown: selectOptionsFaculty,
                                  label: 'Faculty',
                                },
                                {
                                  column_name: 'classroom',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenSelect',
                                  dropdown: selectOptionsClass,
                                  label: 'Class',
                                },
                              ],
                            }}
                          />
                          <TableCell className={classes.selectTableCell}>
                            {row.isEditMode ? (
                              <>
                                <IconButton
                                  aria-label="done"
                                  onClick={() =>
                                    onToggleEditModeSecondWorkshop(row.id)
                                  }
                                >
                                  <DoneIcon />
                                </IconButton>
                                <IconButton
                                  aria-label="revert"
                                  onClick={() => onRevertSecondWorkShop(row.id)}
                                >
                                  <RevertIcon />
                                </IconButton>
                              </>
                            ) : (
                              <>
                                {!row.saves && (
                                  <>
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() =>
                                        onToggleEditModeSecondWorkshop(row.id)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  </>
                                )}
                                {row.saves && (
                                  <>
                                    <IconButton
                                      aria-label="done"
                                      onClick={() =>
                                        handleSecondWorkShop('save', row)
                                      }
                                    >
                                      <DoneIcon />
                                    </IconButton>
                                    <IconButton
                                      aria-label="revert"
                                      onClick={() =>
                                        handleCancelSecondWorkshop(row.id)
                                      }
                                    >
                                      <RevertIcon />
                                    </IconButton>
                                  </>
                                )}
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </KenCard>
          ) : (
            ''
          )}
          <div style={{ marginLeft: '15px' }}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{ marginRight: '15px' }}
              onClick={() => handleSecondSubject()}
            >
              Add Subjects
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => handleSecondWorkShop()}
            >
              Add workshop
            </Button>
          </div>
        </Accordion>
      </Box>
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        open={filterCurrentDialog}
        icon={<RiCheckFill />}
        handleClose={() => handleFilterCurrentDialog()}
        negativeButtonClick={() => handleFilterCurrentDialog()}
        positiveButtonClick={() => handleFilterCurrentDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Program Module"
              options={programOptions}
              value={programValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectProgramChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Type"
              options={selectOptionsType}
              value={typeValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectTypeChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'Start date'}
              value={startData}
              type="date"
              required={true}
              defaultValue={startData}
              onChange={manageStartDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'End date'}
              value={endData}
              type="date"
              required={true}
              defaultValue={endData}
              onChange={manageEndDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Current Semester"
              options={selectOptions}
              value={selectValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Campus"
              options={dropDownOption}
              value={campusValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectCampusChange}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>
      <KenPopover
        id={ids}
        open={opens}
        anchorEl={anchorEls}
        //  onMouseEnter={handlePopoverOpen}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          style: { width: 'auto', padding: '20px' },
        }}
        hideNegativeButton={true}
        hidePositiveButton={true}
      >
        <Grid container spacing={3}>
          <Typography className={`main-title ${classes.popOverHeading}`}>
            Holiday List
          </Typography>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableBodyStyle}>
                  New Year
                </TableCell>
                <TableCell className={classes.tableBodyStyle} align="right">
                  01/01/2022
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableBodyStyle}>Pongal</TableCell>
                <TableCell className={classes.tableBodyStyle} align="right">
                  13/01/2022/14/01/2022
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </KenPopover>
    </Box>
  );
};

export default ProgramDetails;